import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { visibleTiles, useHomeSummary } from "@/components/home/tiles";

// Versione PC: una riga compatta di scorciatoie colorate sopra la panoramica.
export const QuickRow = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";
  const { s, mail } = useHomeSummary(isAdmin);
  const tiles = visibleTiles(isAdmin);
  return (
    <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${tiles.length}, minmax(0, 1fr))` }} data-testid="home-quick-row">
      {tiles.map((t) => (
        <button key={t.key} type="button" onClick={() => navigate(t.to)} data-testid={`quick-${t.key}`}
          className={`rounded-xl border px-3 py-2.5 text-left flex items-center gap-2.5 hover:-translate-y-0.5 hover:shadow-md transition-[transform,box-shadow] duration-200 ${t.tone}`}>
          <span className={`w-8 h-8 rounded-lg ${t.iconBg} text-white flex items-center justify-center shrink-0`}><t.icon className="w-4 h-4" /></span>
          <span className="min-w-0">
            <span className="block text-[13px] font-semibold leading-tight line-clamp-2">{t.title}</span>
            <span className="block text-[11px] opacity-75 truncate">{t.count(s, mail)}</span>
          </span>
        </button>
      ))}
    </div>
  );
};

export default QuickRow;
